export type MktVersionTypes = "v3" | "v4" | "v5";
export function versionToPathPrefix(version: MktVersionTypes) {
  if (version === "v3") return "v3";
  if (version === "v4") return "promotion";
  if (version === "v5") return "v5";
  return `${version}`;
}
